import { useRoutes } from 'react-router-dom';
import { routes } from './app/routes/routes';
import { useAuthInit } from '@/features/auth/hooks/useAuthInit';

export const App = () => {
    useAuthInit(); // инициализация авторизации и рисков

    return useRoutes(routes);
};
